import Vue from 'vue'
import pageMixin from '../../mixins/page'

export default Vue.extend({
  name: 'XpHomePage',
  mixins: [pageMixin],
  data () {
    return {
      childrenPageData: [],
      contentPageData: null
    }
  },
  created () {
    console.log('XpHomePage')
    // this.$xp.history.addHomePage(this.$route.params.id, this.$route.path, this.pageData.Title)
    if (this.pageData.NfcPageId) {
      console.log('XpHomePage.created() set NfcPageID=', this.pageData.NfcPageId)
      window.localStorage.setItem('nfcPageId', this.pageData.NfcPageId)
    }
  },
  mounted () {
    this.childrenPageData = JSON.parse(JSON.stringify(this.pageData.children))
    if (this.childrenPageData.length > 0) {
      // show nav only when tab items > 0
      this.$xp.navigation.preventAutoHide()
      this.$xp.navigation.showNav()
    } else if (this.childrenPageData.length === 1 && this.childrenPageData[0].Class === 'XpSplashScreen') {
      // hide navigation (splash screen is used for example)
      this.$xp.navigation.preventAutoHide()
      this.$xp.navigation.hideNav()
    }
    // this.$xp.navigation.setTabs(this.childrenPageData)
    if (this.childrenPageData.length > 1 && this.$route.query.activeTabId) {
      this.$xp.navigation.setActiveTabId(parseInt(this.$route.query.activeTabId))
    } else if (this.$xp.history.historyParams[`homeActiveTab${this.$route.params.id}`]) {
      this.$xp.navigation.setActiveTabId(parseInt(this.$xp.history.historyParams[`homeActiveTab${this.$route.params.id}`]))
    } else if (this.childrenPageData.length && !this.$xp.navigation.activeTab) {
      this.$xp.navigation.setActiveTabId(this.childrenPageData[0].ID)
    }
    console.log(`XpHomePage redirecting to /page/${this.$xp.navigation.activeTabId}`)
    this.$xp.history.replace(this.$xp.navigation.activeTabId, `/page/${this.$xp.navigation.activeTabId}`)
    this.$router.replace(`/page/${this.$xp.navigation.activeTabId}`)
    // this.loadContentPageData()
  },
  methods: {
    // async loadContentPageData () {
    //   this.saveContentScroll()
    //   this.contentPageData = null
    //   await this.$nextTick()
    //   const data = await this.$xp.http.getPageData(this.$xp.navigation.activeTabId)
    //   this.contentPageData = data
    //   await this.$nextTick()
    //   if (data.Class === 'XpPanorama' || data.Class === 'XpMap' || data.IsFullScreen) {
    //     this.$xp.navigation.allowAutoHide()
    //     this.$xp.navigation.showNav(true)
    //   } else {
    //     this.$xp.navigation.preventAutoHide()
    //     this.$xp.navigation.showNav()
    //   }
    //   this.setScrollFromHistory(`homeContentScroll${this.contentPageData.ID}`)
    //   this.setPseudoCoordinates()
    // },
    // saveContentScroll () {
    //   const scrollableElement = document.querySelector('div.js-page-content')
    //   console.log('SAVE SCROLL', scrollableElement.scrollTop)
    //   if (scrollableElement && this.contentPageData && this.contentPageData.ID) {
    //     this.$xp.history.setHistoryParam(this.$route.params.id, `homeContentScroll${this.contentPageData.ID}`, scrollableElement.scrollTop)
    //   }
    // },
    // setPseudoCoordinates () {
    //   if (this.contentPageData.PseudoCoordinates && this.$xp.positioningInstalled) {
    //     const pseudoEngine = this.$xp.positioning.getEngine('Pseudo')
    //     console.log('set PseudoCoordinates: ', this.contentPageData.PseudoCoordinates)
    //     pseudoEngine && pseudoEngine.setPseudoCoordination(this.contentPageData.PseudoCoordinates)
    //   }
    // },
    // renderContent (h) {
    //   // <div :class="{ 'c-home-page__content': true, 'c-home-page__content--full-width': $xp.navigation.isNavHidden }">
    //   //   <dynamic-page v-if="contentPageData" :pageData="contentPageData"></dynamic-page>
    //   //   <div class="c-home-page__loading" v-else="">
    //   //       <i class="xp xp-spinner xp--large is-spinning"></i>
    //   //   </div>
    //   // </div>
    //   return h('div', { class: { 'c-home-page__content': true, 'c-home-page__content--full-width': this.$xp.navigation.isNavHidden } }, [
    //     this.contentPageData
    //       ? h('dynamic-page-in-page', { props: { pageData: this.contentPageData } })
    //       : h('div', { class: 'c-home-page__loading' }, [h('i', { class: 'xp xp-spinner xp--large is-spinning' })])
    //   ])
    // }
  },
  // beforeDestroy () {
  //   this.$xp.navigation.resetTabs()
  // },
  render () {
    return null
    // return h(
    //   'div',
    //   {
    //     class: 'c-home-page'
    //   }
    //   // [this.renderContent(h)]
    // )
  }
})
